import React, { Component, useEffect, useState } from 'react'
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css'
import 'videojs-contrib-quality-levels'
import 'videojs-hls-quality-selector'

const types = {
  mp4: 'video/mp4',
  m3u8: 'application/x-mpegURL',
}

const getMimeType = url => {
  const parts = url.split('.')
  const extension = parts[parts.length - 1]
  return types[extension]
}

export class VideoPlayer extends Component {
  componentDidMount() {
    let { src, autoplay = false, onEnd = false, onReady = false, poster = false } = this.props

    let options = {
      controls: true,
      autoplay,
      sources: [
        {
          src,
          type: getMimeType(src),
        },
      ],
      plugins: {
        qualityLevels: {},
      },
    }

    if (poster) options.poster = poster

    this.player = videojs(this._video, options, () => {
      if (typeof onReady === 'function') onReady.call()
    })

    if (typeof onEnd === 'function') this.player.on('ended', onEnd)
  }

  componentWillUnmount() {
    if (this.player) this.player.dispose()
  }

  render() {
    let videoProps = {
      ref: el => (this._video = el),
      className: 'video-js vjs-trustmary-skin vjs-big-play-centered vjs-16-9',
    }

    /* Safari Needs crossorigin = anonymous  */
    let ua = navigator.userAgent.toLowerCase()
    let isSafari = ua.indexOf('safari') != -1 && ua.indexOf('chrome') === -1

    if (isSafari) videoProps.crossOrigin = 'anonymous'

    return (
      <div className="video-player">
        <video {...videoProps} />
      </div>
    )
  }
}
